module.exports = "<span class=header><l10n>{{$ctrl.label}}</l10n></span><div class=switch ng-click=$ctrl.toggle()><span class=\"label label-off\"><l10n>OFF</l10n></span><span class=\"label label-on\"><l10n>ON</l10n></span><input type=checkbox ng-model=$ctrl.isTurnedOn> <span class=\"slider round\"></span></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/widgets/toggle-button/toggle-button.html
// module id = 814
// module chunks = 0